export enum BadgeEnum {
    AWARD_WINNER,
    NEW_RELEASE,
    LONG_QUEUE,
    LONGER_SHIPPING,
    MISSING_IN_SERIES,
    HIDDEN_PRODUCT
}

export const mapBadge = (badge: BadgeEnum): string | null => {
    switch (badge) {
        case BadgeEnum.AWARD_WINNER:
            return 'awardWinner';
        case BadgeEnum.NEW_RELEASE:
            return 'newRelease';
        case BadgeEnum.LONG_QUEUE:
            return 'longQueue';
        case BadgeEnum.LONGER_SHIPPING:
            return 'longerShipping';
        case BadgeEnum.MISSING_IN_SERIES:
            return 'missingInSeries';
        case BadgeEnum.HIDDEN_PRODUCT:
            return 'hiddenProduct';
        default:
            return null;
    }
};
